var _ellipse, _ellipse2, _circle, _path, _ellipse3, _ellipse4, _circle2, _path2, _path3, _ellipse5, _ellipse6, _circle3, _path4, _path5, _circle4, _path6, _path7, _ellipse7, _ellipse8, _circle5, _path8, _path9, _circle6, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 285,
    viewBox: "0 0 322 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.3485,
    cy: 4.48337,
    rx: 27.3485,
    ry: 4.48337,
    transform: "matrix(1 0 0 -1 267 47.5571)",
    fill: "url(#paint0_radial_3644_90234)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2084,
    cy: 0.896673,
    rx: 11.2084,
    ry: 0.896673,
    transform: "matrix(1 0 0 -1 283.141 43.9702)",
    fill: "url(#paint1_radial_3644_90234)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 294.511,
    cy: 21.3564,
    r: 19.8564,
    fill: "#FF8A4A",
    stroke: "#FF8A4A",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.767 13.2632L290.239 30.0088L283.832 23.517",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 6.55738,
    rx: 40,
    ry: 6.55738,
    transform: "matrix(1 0 0 -1 218 71.5571)",
    fill: "url(#paint2_radial_3644_90234)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3934,
    cy: 1.31148,
    rx: 16.3934,
    ry: 1.31148,
    transform: "matrix(1 0 0 -1 241.607 66.311)",
    fill: "url(#paint3_radial_3644_90234)",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.236,
    cy: 33.2358,
    r: 29.7358,
    fill: "#06BF97",
    stroke: "#06BF97",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.163 21.3989L251.988 45.891L242.617 36.3962",
    fill: "#06BF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M276.163 21.3989L251.988 45.891L242.617 36.3962",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 10,
    rx: 61,
    ry: 10,
    transform: "matrix(1 0 0 -1 137 104.5)",
    fill: "url(#paint4_radial_3644_90234)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 2,
    rx: 25,
    ry: 2,
    transform: "matrix(1 0 0 -1 173 96.5)",
    fill: "url(#paint5_radial_3644_90234)",
    fillOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.312,
    cy: 52.8305,
    r: 39.9057,
    fill: "#8EEA36",
    stroke: "#8EEA36",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.076 37.1396L190.031 69.6059L177.609 57.0197",
    fill: "#8EEA36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.076 37.1396L190.031 69.6059L177.609 57.0197",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.207,
    cy: 107.311,
    r: 55.1604,
    fill: "#FCD300",
    stroke: "#FCD300",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.727 85.8394L120.875 130.267L103.877 113.044",
    fill: "#FCD300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.727 85.8394L120.875 130.267L103.877 113.044",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167,
    cy: 253,
    rx: 79,
    ry: 13,
    fill: "url(#paint6_radial_3644_90234)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167,
    cy: 253,
    rx: 32,
    ry: 2,
    fill: "url(#paint7_radial_3644_90234)",
    fillOpacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.642,
    cy: 179.953,
    r: 71.1415,
    fill: "#BEAAF3",
    stroke: "#BEAAF3",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.766 152.425L152.546 209.383L130.754 187.302",
    fill: "#BEAAF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.766 152.425L152.546 209.383L130.754 187.302",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.6415,
    cy: 211.915,
    r: 71.1415,
    fill: "#019DF2",
    stroke: "#019DF2",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.333 184.387L58.1128 241.346L36.3203 219.264",
    fill: "#019DF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.333 184.387L58.1128 241.346L36.3203 219.264",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3485 4.48337) rotate(90) scale(4.48337 27.3485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2084 0.896673) rotate(90) scale(0.896673 11.2084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 6.55738) rotate(90) scale(6.55738 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3934 1.31148) rotate(90) scale(1.31148 16.3934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61 10) rotate(90) scale(10 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 2) rotate(90) scale(2 25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167 253) rotate(90) scale(13 79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3644_90234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167 253) rotate(90) scale(2 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcons);
export default __webpack_public_path__ + "static/media/review-Icons.c5da5e946dd8e0b890d842d548be5a6f.svg";
export { ForwardRef as ReactComponent };